// extracted by mini-css-extract-plugin
export default {"heading":"UserDetails_heading__V+IaC","detail":"UserDetails_detail__wvFC2","greenBox":"UserDetails_greenBox__d-6oz","redBox":"UserDetails_redBox__7PTD6"};